import React from 'react';
const Error = ({ message }) => {
    return (React.createElement("div", { className: "full" },
        React.createElement("div", { className: "centered" }, message)));
};
export { Error };
